module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Trash-264b6ad43d79b54be8c047bffb709dd618f41abcd6bedd144a546682c2380250.svg";